// eslint-disable-next-line import/no-default-export
export default class MepFfsClientSpike {
  private readonly maxPollPeriodMillis: number = 30 * 24 * 60 * 60 * 1000;
  private readonly userId: string | undefined;
  private readonly initTime: number;
  private readonly defaultPollingPeriodMins: number = 5;
  private readonly minimumPollingPeriodMins: number = 1;

  private baseUrl: string =
    'https://api.atlassian.com/flags/api/v1/mockEmptyEndpoint?';
  private pollingIntervalMins: number = this.defaultPollingPeriodMins;
  private shouldPoll: boolean;

  constructor(userId: string | undefined, pollingIntervalMins?: number) {
    this.initTime = Date.now();
    this.userId = userId;
    this.shouldPoll = false;
    if (pollingIntervalMins) {
      this.updatePollingValue(pollingIntervalMins);
    }
  }

  /** Helper methods added for easier testing **/
  enablePolling(): void {
    this.shouldPoll = true;
  }

  disablePolling(): void {
    this.shouldPoll = false;
  }

  isPollingEnabled(): boolean {
    return this.shouldPoll;
  }

  getPollingIntervalMins(): number {
    return this.pollingIntervalMins;
  }

  getMaxPollingPeriodMillis() {
    return this.maxPollPeriodMillis;
  }

  // Polling should only occur for 1 month from client initialisation
  shouldContinuePolling() {
    return Date.now() - this.initTime <= this.getMaxPollingPeriodMillis();
  }

  /** Main client logic **/

  initialiseAndPoll(): void {
    this.enablePolling();
    this.callFeatureFlagService('initialisation');
    this.poll();
  }

  updatePollingValue(pollingMins: number) {
    this.pollingIntervalMins =
      pollingMins < this.minimumPollingPeriodMins
        ? this.minimumPollingPeriodMins
        : pollingMins;
  }

  callFeatureFlagService(cause: string) {
    let idString = 'id=undefined-user';

    if (typeof this.userId !== 'undefined') {
      if (this.userId === 'notLoggedIn') {
        idString = 'id=notLoggedIn';
      } else {
        idString = `id=trello-user-${this.userId}`;
      }
    }

    const visibilityStateString = `visibilityState=${document.visibilityState}`;
    const causeString = `cause=${cause}`;

    fetch(
      this.baseUrl + idString + '&' + visibilityStateString + '&' + causeString,
    );
    return;
  }

  poll() {
    if (this.isPollingEnabled() && this.shouldContinuePolling()) {
      setTimeout(() => {
        this.callFeatureFlagService('polling');
        this.poll();
      }, this.pollingIntervalMins * 60 * 1000);
    }
  }
}
